module.exports = __webpack_public_path__ + "static/img/sunlight.57d6972.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/anniversary/sunlight.png
// module id = aWce
// module chunks = 0